module.exports = __webpack_public_path__ + "static/ricardo-b39e5c9563de8227c74995ef121e317b.png";